import { useEffect, useState } from "react";
import AdminModal from "../../../core/admin/adminModal";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { IReview } from "./reviews";
import AdminButton from "../../../core/admin/adminButton";
import AdminBadge from "../../../core/admin/adminBadge";
import AdminConfirm from "../../../core/admin/adminConfirm";
import AdminDetails from "../../../core/admin/adminDetails";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import { useWatches } from "../../../../context/watchProvider";
import Review from "../../../core/review";
import { formatPhoneNumber } from "../../../../utils/functions";

export default function ReviewDetailsModal({ close, review, goodToast, badToast, refresh }: { close: () => void, review: IReview, refresh: () => Promise<null>, goodToast: () => void, badToast: () => void }) {

    const { getAdvertiser } = useWatches();

    const [loading, setLoading] = useState(false);
    const [advertiser, setAdvertiser] = useState<{ [key: string]: any; id: string; } | null>(null);
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        doGetAdvertiser();
        // eslint-disable-next-line
    }, []);

    const doGetAdvertiser = async () => {
        setLoading(true);
        const adv = await getAdvertiser(review.advertiser);
        if (!adv) {
            setLoading(false);
            return null;
        }
        setAdvertiser(adv);
        setLoading(false);
    }

    const handleHideOperation = async () => {
        try {
            setLoading(true);

            const docRef = doc(db, "reviews", review.id);
            const hideValue = review.hidden ? false : true

            await updateDoc(docRef, { hidden: hideValue });
            setLoading(false);
            goodToast();
            await refresh();
        } catch (error) {
            console.log(error);
            badToast();
            setLoading(false);
        }
    }

    return (
        <AdminModal
            close={close}
            title="Avaliação"
            subtitle={review.hidden ? <AdminBadge tone="danger" dot>Escondida</AdminBadge> : <AdminBadge tone="success" dot>Visível</AdminBadge>}
            footer={
                loading ?
                    undefined
                    : edit ?
                        <AdminConfirm
                            className="w-full"
                            message={review.hidden ? "Deseja exibir essa avaliação?" : "Deseja esconder essa avaliação?"}
                            cancelLabel="Cancelar"
                            danger={!review.hidden}
                            onConfirm={handleHideOperation}
                            onCancel={() => setEdit(false)}
                        />
                        :
                        <AdminButton variant={review.hidden ? "primary" : "danger"} onClick={() => setEdit(true)}>{review.hidden ? "Exibir avaliação" : "Esconder avaliação"}</AdminButton>
            }
        >
            {
                loading ?
                    <AdminLoading />
                    :
                    <div className="flex flex-col gap-6">
                        <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
                            <Review review={review} />
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <section>
                                <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-3">Sobre o anunciante</h3>
                                <AdminDetails
                                    columns={1}
                                    items={[
                                        { label: "Nome", value: advertiser?.name },
                                        { label: "E-mail", value: advertiser?.email },
                                        { label: "Telefone", value: formatPhoneNumber(advertiser?.phoneNumber) },
                                    ]}
                                />
                            </section>
                            <section>
                                <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-3">Sobre o relógio</h3>
                                <AdminDetails columns={1} items={[{ label: "ID", value: <span className="font-mono text-xs">{review.watch}</span> }]} />
                            </section>
                        </div>
                    </div>
            }
        </AdminModal>
    )
}
